import RUF from "../../../util/redux";

export function metaSetCurrentEmploymentIndex(state, action) {
  return RUF.updateObject(state, {
    meta: RUF.updateObject(state.meta, {
      currentEmploymentIndex: parseInt(action.payload)
    })
  });
}
